export const REALTIME_NOTIFICATION_EVENT = 'yubu-notification';

export function emitRealtimeNotification(detail) {
  try {
    if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') return;
    window.dispatchEvent(new CustomEvent(REALTIME_NOTIFICATION_EVENT, { detail }));
  } catch {
    // ignore
  }
}

export function subscribeRealtimeNotifications(handler) {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return () => {};
  }

  window.addEventListener(REALTIME_NOTIFICATION_EVENT, handler);
  return () => window.removeEventListener(REALTIME_NOTIFICATION_EVENT, handler);
}
